import {connect} from 'react-redux';
import Contact from '../components/contact/contact';

const mapStateToProps = (state) => {
  return {entity: state.store.entity};
};

export default connect(mapStateToProps)(Contact);



// WEBPACK FOOTER //
// ./src/containers/contact.js